/**
 * Soft stop against the crm-sync lambda's 900s hard timeout. Shared with `infrastructure` (the
 * dashboard's theoretical-ceiling marker) so the two can't drift out of sync with each other.
 */
export const TIME_BUDGET_MS = 840_000;

/** `HUBSPOT_LIMITER_OPTIONS.minTime` in `lambdas/crm-sync/index.ts` - throttles HubSpot calls to 1 per this many ms. */
export const HUBSPOT_CALL_MIN_TIME_MS = 500;

/** The most HubSpot calls one tick's time budget can fit through the limiter, whatever the backlog. */
export const HUBSPOT_CALLS_CEILING_PER_RUN = Math.floor(TIME_BUDGET_MS / HUBSPOT_CALL_MIN_TIME_MS);
